import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { CardScroller } from "@whoosh/design-system/src/components/display";
import { Text } from "@whoosh/design-system/src/components/primitive";

import { EventCardWrapper } from "./EventCardWrapper";
import { EventsList_EventsConnection$key } from "./__generated__/EventsList_EventsConnection.graphql";

type EventsListProps = {
  eventListFragRef: EventsList_EventsConnection$key | null;
  loadedFeaturedEvents?: boolean;
  eventNounPlural: string;
};

export const EventsList = ({
  eventListFragRef,
  loadedFeaturedEvents,
  eventNounPlural,
}: EventsListProps) => {
  const data = useFragment(EventsListFragmentString, eventListFragRef);

  const events =
    data?.edges?.map((eventsEdge) => {
      return {
        node: eventsEdge?.node,
        id: eventsEdge?.node?.id ?? "",
      };
    }) || [];

  return (
    <CardScroller
      data={events || []}
      paddingHorizontal={{ base: 6, md: 16, lg: 0 }}
      hideMargin={false}
      titleElement={
        <Text
          variant={{ base: "mainHeading", lg: "mainTitle2" }}
          mb={{ base: 0, lg: 3 }}
          px={{ base: 6, md: 16, lg: 0 }}
          aria-label={t`Events Header Text`}
        >
          {loadedFeaturedEvents
            ? `${t`Featured`} ${eventNounPlural}`
            : eventNounPlural}
        </Text>
      }
      renderItem={(item) =>
        item ? (
          <EventCardWrapper eventCardWrapperRef={item.node ?? null} />
        ) : null
      }
    />
  );
};

export const EventsListFragmentString = graphql`
  fragment EventsList_EventsConnection on EventConnection {
    edges {
      node {
        id
        ...EventCardWrapper_Event
      }
    }
  }
`;
